/** 分期商城相关 埋点 汇总 */
/** 分期商城模块-曝光 - expose */
export const shopMallModuleExpose = 'finance_loan_shopMall';
/** 分期商城模块-按钮点击 - click */
export const shopMallModuleClick = `${shopMallModuleExpose}_button`;

/** 分期商城协议-曝光 - expose */
export const shopMallAgreementPopupExpose = `${shopMallModuleExpose}_agreementPopup_expose`;
/** 分期商城协议-点击 - click */
export const shopMallAgreementPopupClick = `${shopMallModuleExpose}_agreementPopup_click`;


/** 贷超半流程 提现结果页 卡片 */
export const dcHalfApplyCard = 'finance_dcHalfApply_card';

/** 贷超半流程协议-曝光 - expose */
export const dcHalfApplyAgreementExpose = 'finance_dcHalfApply_agreement';
/** 贷超半流程协议-点击 - click */
export const dcHalfApplyAgreementClick = 'finance_dcHalfApply_contractconfirm';
